// extracted by mini-css-extract-plugin
module.exports = {"root":"NatRulesAddForm_root__124Ry","natInfo":"NatRulesAddForm_natInfo__dcSHm","alert":"NatRulesAddForm_alert__u1tPc","natTypeInput":"NatRulesAddForm_natTypeInput__D3CAH"};